import React, { useState } from "react";
import Dropdown, { Option, SectionOption } from "../components/Dropdown";
import Icon from "../components/Icon";

// const options: Option[] = [
//     { label: "Option 1", value: "option1" },
//     { label: "Option 2", value: "option2" },
//     { label: "Option 3", value: "option3" },
//     { label: "Option 4", value: "option4" },
// ];

const options: SectionOption[] = [
  {
    section: "Fruits",
    options: [
      { value: "apple", label: "Apple" },
      { value: "banana", label: "Banana" },
      { value: "orange", label: "Orange" },
    ],
  },
  {
    section: "Vegetables",
    options: [
      { value: "carrot", label: "Carrot" },
      { value: "lettuce", label: "Lettuce" },
      { value: "tomato", label: "Tomato" },
    ],
  },
];

function App() {
  const [selectedOption, setSelectedOption] = useState<null>(null);

  return (
    <div className="flex w-full h-screen items-center justify-center">
      <div className="flex w-4/12 justify-center">
        <Dropdown
          dropdownLabel="Primary Stock"
          options={options}
          onSelect={(option: any) => setSelectedOption(option)}
          selectedOption={selectedOption}
          placeholder="Search"
          endAdornment={<Icon name="ArrowDown" />}
        />
      </div>
    </div>
  );
}

export default App;
